import { render } from "./ContentsListButton.vue?vue&type=template&id=95d3e08e&scoped=true"
import script from "./ContentsListButton.vue?vue&type=script&lang=js"
export * from "./ContentsListButton.vue?vue&type=script&lang=js"

import "./ContentsListButton.vue?vue&type=style&index=0&id=95d3e08e&scoped=true&lang=stylus"

import exportComponent from "C:\\Users\\DGWA\\Documents\\tokyo-shoseki_R8_042024\\08k\\08k_sigb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95d3e08e"]])

export default __exports__